import { FormikHelpers } from "formik";
import { useCreateSpeed } from "./api/createSpeed";
import SpeedForm from "./SpeedForm";


const CreateSpeed = ({handleCloseModal}: CreateSpeedProps)  => {
  const createSpeedMutation = useCreateSpeed({data: {}});

  const initialValues: IPostNewSpeed = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewSpeed, { setSubmitting }: FormikHelpers<IPostNewSpeed>): Promise<void> => {
    try {
      await createSpeedMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <SpeedForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateSpeedProps {
  handleCloseModal: () => void;
}

export default CreateSpeed;